import capitalize from 'lodash-es/capitalize'

import { DEFAULT_DATE_LOCALE, WEEK_FIRST_DAY } from '../../../constants/date'

/**
 * @param {number} day - Day number: [0-6]
 * @param [locale]
 */
export function formatWeekDay(
  day = WEEK_FIRST_DAY,
  locale = DEFAULT_DATE_LOCALE
) {
  return capitalize(locale.localize.day(day, { width: 'short' }))
}
